module.exports = __webpack_public_path__ + "static/img/icon_footer_slogan.47b1242.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_footer_slogan.png
// module id = azBx
// module chunks = 1